import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnDestroy, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { ProjectService } from '../Services/project.service';
import { Chart } from 'chart.js';
import { ChartToolTipServiceService } from '../Services/chart-tool-tip-service.service';
import { LogsDisplayModalComponent } from '../Admin/logs-display-modal/logs-display-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from '../Services/sharedService';
import { log } from 'console';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { colors } from '../colors';
import { SanitizationService } from '../Services/sanitization.service';
import moment from 'moment';
import { ConductTimelog } from '../interface/conduct-timelog';
import { ConductTimelogService, SuperSeeOverlapDetails } from '../Services/conduct-timelog.service';

@Component({
  selector: 'app-stacked-chart',
  templateUrl: './stacked-chart.component.html',
  styleUrls: ['./stacked-chart.component.css'],
  providers: [DatePipe],
  standalone: false
})
export class StackedChartComponent implements AfterViewInit, OnDestroy {
  @ViewChild("myChart", { static: true })
  myChart: ElementRef<HTMLCanvasElement>;
  chart: Chart;
  @Input("type") type;
  @Input("chartdata") chartdata;
  @Input("weekArr") weekArr;
  @Input("minValue") minValue;
  @Input("maxValue") maxValue: any = 23.59;
  @Input("startDate") startDate; // For virtual shift date range
  @Input("endDate") endDate; // For virtual shift date range
  @Input() workingHoursStart: string;
  @Input() workingHoursEnd: string;
  currentId;
  totalWorkingArr: any;
  inOut: any;
  @Input()
  get totalWorkingArray() {
    return this.totalWorkingArr;
  }
  set totalWorkingArray(data) {
    this.totalWorkingArr = data;
  }

  isdata = true;
  tooltipTitle: any;
  tooltipContent: any;
  tooltipTime;
  index = 0;
  @Input("data") data;
  @Input("sessionData") sessionData = [];
  @Input("labels") labels;
  @Input("id") id;
  @Input("tempDataTooltip") tempDataTooltip;
  @Input("newSessionData") newSessionData;
  @Input()
  get conductTimelogs(): ConductTimelog[] {
    return this._conductTimelogs;
  }
  set conductTimelogs(val: ConductTimelog[]) {
    this._conductTimelogs = Array.isArray(val) ? val : [];
    this.refreshDistinctConductProjects();
  }
  private _conductTimelogs: ConductTimelog[] = [];
  distinctConductProjects: { name: string; color: string }[] = [];

  readonly conductBarColors: string[] = [ConductTimelogService.PRIMARY_CONDUCT_COLOR];
  private conductProjectColorMap = new Map<string, string>();

  hoveredConductTask: ConductTimelog | null = null;
  hoveredConductTaskColor = ConductTimelogService.PRIMARY_CONDUCT_COLOR;
  hoveredConductTaskTimeRange = '';
  hoveredConductTaskDuration = '';
  hoveredConductActiveInWindow = '';
  hoveredConductIdleSecs = 0;
  hoveredConductIdleText = '';
  hoveredConductOfflineSecs = 0;
  hoveredConductOfflineText = '';
  hoveredSuperSeeTimeRange = '';
  hoveredSuperSeeDuration = '';
  hoveredConductTimeDifferenceSecs = 0;
  hoveredConductTimeDifference = '';
  conductTooltipX = 0;
  conductTooltipY = 0;

  private renderedConductPills: Array<{
    x1: number;
    x2: number;
    y1: number;
    y2: number;
    centerX: number;
    log: ConductTimelog;
    timeRangeText: string;
    durationText: string;
    activeOverlapText: string;
    idleSecs?: number;
    offlineSecs?: number;
    idleText?: string;
    offlineText?: string;
    superSeeTimeRangeText: string;
    superSeeDurationText: string;
    differenceSecs: number;
    differenceText: string;
    color: string;
  }> = [];

  private boundCanvasMouseMove = (e: MouseEvent) => this.handleCanvasMouseMove(e);
  private boundCanvasMouseLeave = () => this.handleCanvasMouseLeave();
  private boundCanvasClick = (e: MouseEvent) => this.handleCanvasClick(e);

  barChartTipsHorizontal: any;
  barChartTipsBar: any;
  @ViewChild('horizontalBarChartDiv') horizontalBarChartDiv!: ElementRef;
  @ViewChild('app_usage_tooltip_horizontal1', { static: false }) app_usage_tooltip_horizontal1: ElementRef;
  @ViewChild('tooltipBarChart1', { static: false }) tooltipBarChart1: ElementRef;
  @ViewChild('conductTooltipRef', { static: false }) conductTooltipRef?: ElementRef;
  private static readonly HORIZONTAL_TOTALS_COLUMN_WIDTH = 156;
  private static readonly HORIZONTAL_TOTALS_COLUMN_OFFSET = 12;
  newData: any;
  isstartPage = true;
  totalAppUsageHours: any
  totalIdleHours: any
  // totalWorkingHours: any;
  clockIn: any
  clockOut: any
  singleDayLog: any
  hoverIndexval;
  hoverRowIndex: number | null = null;
  selectedRowIndex: number | null = null;
  currentRoute;
  userName;
  sortedArr;
  /** Last Chart.js tooltip caret (canvas coords) — reapplied on scroll/resize so fixed tooltips track the chart */
  private _lastTimelineCaret = { x: 0, y: 0 };
  private _lastBarCaret = { x: 0, y: 0 };
  /** Bounded retries when the horizontal chart DOM is not ready on first ngOnChanges */
  private _horizontalChartMountAttempts = 0;
  private static readonly _HORIZONTAL_CHART_MOUNT_MAX = 8;
  private readonly boundRepositionTooltipsOnScrollOrResize = () =>
    this.repositionTooltipsAfterScrollOrResize();
  totalProductive = '00hrs 00min'
  totalIdle = '00hrs 00min'
  inOutInside: any;
  inOutOutside: any;
  totalProductiveInside = '00hrs 00min';
  totalIdleInside = '00hrs 00min';
  offlineInside = '00hrs 00min';
  totalProductiveOutside = '00hrs 00min';
  totalIdleOutside = '00hrs 00min';
  offlineOutside = '00hrs 00min';

  constructor(
    private renderer: Renderer2,
    private _projectService: ProjectService,
    private _chartService: ChartToolTipServiceService,
    public dialog: MatDialog,
    private _sharedService: SharedService,
    private _datepipe: DatePipe,
    private router: Router,
    private sanitization: SanitizationService,
    private el: ElementRef,
    private cdr: ChangeDetectorRef,
    private conductService: ConductTimelogService
  ) {
    this.currentRoute = this.router.url;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    // Close tooltips when clicking outside this component
    if (!this.el.nativeElement.contains(event.target as Node)) {
      this.clearTooltipData();
    }
  }

  ngOnInit() {
  }

  private isMultiDayRange(): boolean {
    if (!this.startDate || !this.endDate) {
      return false;
    }
    const start = new Date(this.startDate);
    const end = new Date(this.endDate);
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
      return false;
    }
    return start.toDateString() !== end.toDateString();
  }

  private isVirtualShiftEnabled(): boolean {
    const hasVirtualShiftScale = Number(this.maxValue) > 24;
    if (!hasVirtualShiftScale) {
      return false;
    }
    // Respect selected filters: only render day-2 timeline when range actually spans multiple days.
    return this.isMultiDayRange();
  }

  private getEffectiveHorizontalMax(): number {
    const rawMax = Number(this.maxValue);
    if (this.isVirtualShiftEnabled()) {
      return Number.isFinite(rawMax) ? rawMax : 48;
    }
    return 23.59;
  }

  /** v4: label is a string; old template used tooltipTitle[0] which was only correct when label was a one-element array */
  get tooltipDayLabel(): string {
    const t = this.tooltipTitle;
    if (t == null || t === '') {
      return '';
    }
    if (Array.isArray(t)) {
      return t[0] != null ? String(t[0]) : '';
    }
    return String(t);
  }

  ngOnDestroy() {
    document.removeEventListener('scroll', this.boundRepositionTooltipsOnScrollOrResize, true);
    window.removeEventListener('resize', this.boundRepositionTooltipsOnScrollOrResize);
    this.clearTooltipData();
    if (this.chart) {
      if (this.chart.canvas && typeof this.chart.canvas.removeEventListener === 'function') {
        this.chart.canvas.removeEventListener('mousemove', this.boundCanvasMouseMove);
        this.chart.canvas.removeEventListener('mouseleave', this.boundCanvasMouseLeave);
        this.chart.canvas.removeEventListener('click', this.boundCanvasClick, true);
      }
      if (typeof this.chart.destroy === 'function') {
        this.chart.destroy();
      }
      this.chart = null;
    }
    this.clearHorizontalTimelineMinHeight();
  }

  ngOnChanges(changes: SimpleChanges) {
    // Check if maxValue indicates virtual shift mode (48 hours)
    const isVirtualShift = this.isVirtualShiftEnabled();

    // Check if data, labels, or sessionData have changed
    const dataChanged = changes['data'] && changes['data'].currentValue !== changes['data'].previousValue;
    const labelsChanged = changes['labels'] && changes['labels'].currentValue !== changes['labels'].previousValue;
    const sessionDataChanged = changes['sessionData'] && changes['sessionData'].currentValue !== changes['sessionData'].previousValue;
    const maxValueChanged = changes['maxValue'] && changes['maxValue'].currentValue !== changes['maxValue'].previousValue;
    const startDateChanged = changes['startDate'] && changes['startDate'].currentValue !== changes['startDate'].previousValue;
    const endDateChanged = changes['endDate'] && changes['endDate'].currentValue !== changes['endDate'].previousValue;
    const idChanged = changes['id'] && changes['id'].currentValue !== changes['id'].previousValue;

    // If any relevant data has changed, destroy existing chart and recreate
    if (dataChanged || labelsChanged || idChanged || sessionDataChanged || maxValueChanged || startDateChanged || endDateChanged) {
      // Clear tooltip data and hide tooltips when data changes (e.g., profile switch)
      this.clearTooltipData();

      // Destroy existing chart if it exists
      if (this.chart) {
        if (this.chart.canvas && typeof this.chart.canvas.removeEventListener === 'function') {
          this.chart.canvas.removeEventListener('mousemove', this.boundCanvasMouseMove);
          this.chart.canvas.removeEventListener('mouseleave', this.boundCanvasMouseLeave);
          this.chart.canvas.removeEventListener('click', this.boundCanvasClick, true);
        }
        if (typeof this.chart.destroy === 'function') {
          this.chart.destroy();
        }
        this.chart = null;
        this.clearHorizontalTimelineMinHeight();
      }
    }

    const conductTimelogsChanged = changes['conductTimelogs'] && changes['conductTimelogs'].currentValue !== changes['conductTimelogs'].previousValue;
    if (conductTimelogsChanged) {
      this.refreshDistinctConductProjects();
      this.cdr.markForCheck();
      if (this.chart && !dataChanged && !labelsChanged) {
        this.chart.update('none');
      }
    }

    if (this.sessionData && this.sessionData.length && !isVirtualShift) {
      // Only call getMaxWorkingTime for single day view
      this.getMaxWorkingTime();
      this.createBarChart();
    }
    else if (this.sessionData && this.sessionData.length && isVirtualShift) {
      this.createBarChart();
    }
    else if (this.data && this.data.length) {
      // Create chart even if sessionData is empty but data exists
      this.createBarChart();
    }

  }

  ngAfterViewInit() {
    document.addEventListener('scroll', this.boundRepositionTooltipsOnScrollOrResize, true);
    window.addEventListener('resize', this.boundRepositionTooltipsOnScrollOrResize);
    this.createBarChart();
  }

  private repositionTooltipsAfterScrollOrResize(): void {
    if (!this.chart?.canvas) return;
    const chart = this.chart;
    if (this.type === 'horizontal') {
      if (this.selectedRowIndex !== null) {
        this.applyHorizontalAppUsageTooltipPosition(chart, this._lastTimelineCaret.x, this._lastTimelineCaret.y);
      }
      if (this.hoveredConductTask) {
        const activePill = this.renderedConductPills.find(p => p.log === this.hoveredConductTask);
        if (activePill) {
          this.updateConductTooltipPosition(activePill);
          this.cdr.markForCheck();
        }
      }
    } else {
      const el = this.tooltipBarChart1?.nativeElement as HTMLElement;
      if (!el || window.getComputedStyle(el).display === 'none') return;
      this.applyVerticalBarTooltipPosition(chart, this._lastBarCaret.x, this._lastBarCaret.y);
    }
  }

  /**
   * Chart.js caretX/Y are in canvas bitmap coordinates; CSS may scale the canvas.
   * Map to viewport pixels so fixed tooltips align with the bar/point.
   */
  private caretCanvasToViewport(chart: Chart, caretX: number, caretY: number): { vx: number; vy: number } {
    const el = chart.canvas;
    const rect = el.getBoundingClientRect();
    const bw = el.width > 0 ? el.width : 1;
    const bh = el.height > 0 ? el.height : 1;
    return {
      vx: rect.left + (caretX / bw) * rect.width,
      vy: rect.top + (caretY / bh) * rect.height,
    };
  }

  private applyHorizontalAppUsageTooltipPosition(chart: Chart, caretX: number, caretY: number): void {
    const tooltipEl = this.app_usage_tooltip_horizontal1?.nativeElement as HTMLElement;
    if (!tooltipEl || !chart?.canvas) return;
    const { vx, vy } = this.caretCanvasToViewport(chart, caretX, caretY);
    const tipW = tooltipEl.offsetWidth || 420;
    const tipH = tooltipEl.offsetHeight || 360;
    const gap = 10;
    const margin = 16;
    const rawX = vx + gap;
    const finalX = (rawX + tipW + margin > window.innerWidth)
      ? Math.max(margin, vx - tipW - gap)
      : Math.max(margin, rawX);
    const rawY = vy - tipH - gap;
    const finalY = rawY < margin
      ? Math.min(window.innerHeight - tipH - margin, vy + gap)
      : rawY;
    tooltipEl.style.left = `${finalX}px`;
    tooltipEl.style.top = `${finalY}px`;
  }

  private applyVerticalBarTooltipPosition(chart: Chart, caretX: number, caretY: number): void {
    const tooltipEl = this.tooltipBarChart1?.nativeElement as HTMLElement;
    if (!tooltipEl || !chart?.canvas) return;
    const { vx, vy } = this.caretCanvasToViewport(chart, caretX, caretY);
    const tipW = tooltipEl.offsetWidth || 450;
    const tipH = tooltipEl.offsetHeight || 300;
    const gap = 8;
    const margin = 16;
    const rawX = vx + gap;
    const finalX = (rawX + tipW + margin > window.innerWidth)
      ? Math.max(margin, vx - tipW - gap)
      : Math.max(margin, rawX);
    // Prefer below the bar so the panel stays over the chart, not over week/date controls above
    const rawYBelow = vy + gap;
    const finalY = (rawYBelow + tipH + margin > window.innerHeight)
      ? Math.max(margin, vy - tipH - gap)
      : rawYBelow;
    tooltipEl.style.left = finalX + 'px';
    tooltipEl.style.top = finalY + 'px';
  }

  getMaxWorkingTime(): void {
    if (!this.sessionData || this.sessionData.length === 0) {
      this.maxValue = '00.00';
      return;
    }

    // Step 1: Get the max working time from sessionData
    const maxWorkingTime = this.sessionData.reduce((max, item) => {
      return item.working > max ? item.working : max;
    }, '00:00:00');

    // Step 2: Convert max working time to total minutes
    const inputMinutes = this.getMinutesFromMidnight(maxWorkingTime);

    // Step 3: Define thresholds and map them to minutes
    const thresholds = ['08:00', '16:00', '23:59'];
    const thresholdMinutes = thresholds.map(this.getMinutesFromMidnight);

    // Step 4: Find the first threshold greater than or equal to the input
    const matchingIndex = thresholdMinutes.findIndex(minutes => inputMinutes <= minutes);
    const closestThreshold = thresholds[matchingIndex !== -1 ? matchingIndex : thresholds.length - 1];

    // Step 5: Format and assign maxValue
    const formatted = this._datepipe.transform(`2000-01-01T${closestThreshold}`, 'HH.mm');
    this.maxValue = formatted ?? '00.00';
  }

  removePlaceholderElements() {
    if (this.horizontalBarChartDiv) {
      const placeholders = this.horizontalBarChartDiv.nativeElement.querySelectorAll('canvas');
      for (var i = 0; i < placeholders.length; i++) {
        this.renderer.removeChild(this.horizontalBarChartDiv.nativeElement, placeholders[i]);
      }
    }
  }

  getMinutesFromMidnight(time) {
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
  }

  updateExistingChart() {
    if (!this.chart) return;

    this.clearTooltipData();
    this.refreshDistinctConductProjects();

    this.chart.data.labels = this.labels;
    this.chart.data.datasets = this.data;

    // v4: scales are flat objects, not arrays.
    // Weekday Statistics uses a category x-axis — do not apply 0–24h min/max there.
    const scaleOptions = (this.chart.options as any).scales;
    if (scaleOptions?.x && this.type === 'horizontal') {
      scaleOptions.x.max = this.getEffectiveHorizontalMax();
      scaleOptions.x.min = this.minValue ? this.minValue : 0.0;
    }

    this.reattachTooltipHandlers();
    this.chart.update();
    this.applyHorizontalTimelineMinHeight();
    this.scheduleBarChartResize();
  }

  /**
   * Horizontal timeline: 48h mode uses extra top layout padding for day headers, which
   * shrinks the bar plot when maintainAspectRatio is true. Turn off ratio locking and
   * set a row-based min-height so spacing matches 24h.
   */
  private applyHorizontalTimelineMinHeight(): void {
    if (this.type !== 'horizontal' || !this.horizontalBarChartDiv?.nativeElement) {
      return;
    }
    const el = this.horizontalBarChartDiv.nativeElement;
    const n = Array.isArray(this.labels) ? this.labels.length : 0;
    if (n <= 0) {
      el.style.minHeight = '';
      return;
    }
    // Same row pitch for 24h and 48h so employee rows feel equally spaced (48h still uses extra chart top padding for day headers).
    const perRow = 56;
    const chrome = 175;
    el.style.minHeight = `${Math.round(n * perRow + chrome)}px`;
  }

  private clearHorizontalTimelineMinHeight(): void {
    if (this.horizontalBarChartDiv?.nativeElement) {
      this.horizontalBarChartDiv.nativeElement.style.minHeight = '';
    }
  }

  createBarChart() {
    // Clear tooltip data before creating/updating chart
    this.clearTooltipData();
    this.refreshDistinctConductProjects();

    // If chart already exists, update it instead of creating a new one
    if (this.chart) {
      this.updateExistingChart();
      return;
    }

    const canvas = this.renderer.createElement("canvas");

    this.removePlaceholderElements()

    const containerId = this.type == 'bar' ? 'chartContainer2' : (this.type == 'horizontal' ? 'chartContainer' : null);
    const containerEl =
      this.type === 'horizontal' && this.horizontalBarChartDiv?.nativeElement
        ? this.horizontalBarChartDiv.nativeElement
        : (containerId ? document.getElementById(containerId) : null);
    if (!containerEl) {
      const willRetryHorizontal =
        this.type === 'horizontal' &&
        !this.chart &&
        this._horizontalChartMountAttempts < StackedChartComponent._HORIZONTAL_CHART_MOUNT_MAX;
      if (willRetryHorizontal) {
        this._horizontalChartMountAttempts++;
        queueMicrotask(() => {
          if (!this.chart) {
            this.createBarChart();
          }
        });
      } else if (!willRetryHorizontal && this.type === 'horizontal') {
        this._horizontalChartMountAttempts = 0;
      }
      if (!willRetryHorizontal) {
        // Hidden tabs / teardown, or horizontal mount retries exhausted.
        console.warn(`StackedChart: container element not found for type='${this.type}' (id='${containerId}'). Skipping chart render.`);
      }
      return;
    }

    this._horizontalChartMountAttempts = 0;

    if (this.type == 'bar') {
      const existingCanvas = containerEl.querySelector('canvas');
      if (existingCanvas) {
        existingCanvas.remove();
      }
      this.renderer.appendChild(containerEl, canvas);
    } else if (this.type == 'horizontal') {
      // Remove all existing canvases before appending the new one to prevent ghost renders
      const existingCanvases = containerEl.querySelectorAll('canvas');
      existingCanvases.forEach((c: HTMLElement) => {
        c.removeEventListener('mousemove', this.boundCanvasMouseMove);
        c.removeEventListener('mouseleave', this.boundCanvasMouseLeave);
        c.removeEventListener('click', this.boundCanvasClick, true);
        c.remove();
      });
      canvas.addEventListener('mousemove', this.boundCanvasMouseMove);
      canvas.addEventListener('mouseleave', this.boundCanvasMouseLeave);
      canvas.addEventListener('click', this.boundCanvasClick, true);
      this.renderer.appendChild(containerEl, canvas);
    }

    // const backgroundColors = this.generateRandomColors(this.data.length);

    const ctx = canvas.getContext("2d");
    if (!ctx) {
      console.warn('StackedChart: 2d canvas context not available. Skipping chart render.');
      return;
    }

    let ticks = {};
    let backgroundColors = [];

    // Check if this is virtual shift mode (48 hours)
    const isVirtualShift = this.isVirtualShiftEnabled();
    const isHorizontalChart = this.type === 'horizontal';
    const startDate = this.startDate;
    const endDate = this.endDate;
    const day1 = new Date(startDate);
    const day2 = new Date(endDate);

    ticks = {
      min: this.minValue ? this.minValue : 0.0,
      max: isHorizontalChart ? this.getEffectiveHorizontalMax() : (this.maxValue ? this.maxValue : 23.59),
      beginAtZero: false,
    };

    if (this.type == 'horizontal') {
      ticks['stepSize'] = isVirtualShift ? 1 : 1; // Show 1-hour increments for both modes
    }



    backgroundColors = colors.backgroundColorsStack;
    this.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.labels,
        datasets: this.data,
      },
      options: {
        indexAxis: this.type == 'horizontal' ? 'y' : 'x',
        // Restore v2 horizontalBar behaviour: clicking any segment activates the full row
        interaction: {
          mode: this.type === 'horizontal' ? 'index' : 'nearest',
          intersect: true,
        },
        layout: {
          padding: {
            top: isVirtualShift ? 60 : (this.type === 'bar' ? 4 : 0),
            right: this.type === 'horizontal' ? StackedChartComponent.HORIZONTAL_TOTALS_COLUMN_WIDTH : (this.type === 'bar' ? 6 : 0),
            left: this.type === 'bar' ? 8 : 0,
            bottom: this.type === 'bar' ? 2 : 0,
          }
        },
        events: this.type !== 'horizontal' ? ["touchstart", "touchmove", "click"] : ["mousemove", "click", "mouseout"],
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            enabled: false,
            mode: 'index',
            external: (this.type !== 'horizontal')
              ? ((context: any) => {
                const { chart, tooltip } = context;
                const tooltipEl: any = this.tooltipBarChart1?.nativeElement;
                const dataPoints: any = tooltip.dataPoints;

                if (dataPoints && dataPoints.length > 0) {
                  const hoveredIndex = dataPoints[0].dataIndex;
                  this.hoverIndexval = hoveredIndex;

                  // v4: for vertical bar, value is parsed.y
                  const val = dataPoints[0].parsed?.y ?? 0;
                  const hours = Math.floor(val);
                  const minutes = Math.floor((val - hours) * 60);
                  const seconds = Math.floor(((val - hours) * 60 - minutes) * 60);

                  const formattedHours = hours.toString().padStart(2, '0');
                  const formattedMinutes = minutes.toString().padStart(2, '0');
                  const formattedSeconds = seconds.toString().padStart(2, '0');

                  const timeFunCalls = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
                  // v4: label is the x-axis category label
                  this.tooltipTitle = dataPoints[0].label;
                  if (dataPoints[0].datasetIndex == 1) {
                    this.tooltipContent = "Active Hours";
                    this.tooltipTime = timeFunCalls;
                  } else {
                    this.tooltipContent = "Idle Hours";
                    this.tooltipTime = timeFunCalls;
                  }
                }

                if (!dataPoints) {
                  this._lastBarCaret = { x: 0, y: 0 };
                  tooltipEl.style.display = 'none';
                } else {
                  tooltipEl.style.display = 'block';
                }

                if (dataPoints && tooltipEl) {
                  this._lastBarCaret = { x: tooltip.caretX, y: tooltip.caretY };
                  this.applyVerticalBarTooltipPosition(chart, tooltip.caretX, tooltip.caretY);
                }
              })
              : ((context: any) => {
                const { chart, tooltip } = context;
                const dataPoints: any = tooltip.dataPoints;

                if (!dataPoints) {
                  this._lastTimelineCaret = { x: 0, y: 0 };
                  return;
                }
                if (this.selectedRowIndex !== null) {
                  // Keep tooltip anchored to the selected row/item.
                  // Hovering other rows must not move a click-opened tooltip.
                  this.applyHorizontalAppUsageTooltipPosition(
                    chart,
                    this._lastTimelineCaret.x,
                    this._lastTimelineCaret.y
                  );
                  return;
                }
              }),
          },
        },
        onHover: (async (evt: any, activeElements: any[]) => {
          const activePoint = activeElements[0];
          if (this.type == 'horizontal') {
            // v4: activeElements array is passed directly to onHover
            const eventType = evt?.native?.type;
            if (!activePoint) {
              // Keep selected row details visible on mouseout/mousemove gaps.
              // Only clear when user explicitly clicks empty canvas.
              if (eventType === 'click') {
                this.clearTooltipData();
              }
              if (eventType === 'mouseout') {
                this.hoverRowIndex = null;
              }
              if (!this.isMouseOverConductPill(evt?.native)) {
                this.chart.canvas.style.cursor = 'default';
              }
              return;
            }

            if (eventType === 'mousemove') {
              this.hoverRowIndex = activePoint.index;
              this.chart.canvas.style.cursor = 'pointer';
              return;
            }
            if (eventType !== 'click') {
              return;
            }

            this.inOut = [];
            this.inOutInside = [];
            this.inOutOutside = [];
            this.totalProductive = '00hrs 00min';
            this.totalIdle = '00hrs 00min';
            this.totalProductiveInside = '00hrs 00min';
            this.totalIdleInside = '00hrs 00min';
            this.offlineInside = '00hrs 00min';
            this.totalProductiveOutside = '00hrs 00min';
            this.totalIdleOutside = '00hrs 00min';
            this.offlineOutside = '00hrs 00min';
            this.clockIn = null;
            this.clockOut = null;
            this.totalAppUsageHours = null;
            this.totalIdleHours = null;
            const index = activePoint.index;
            this.userName = this.chart.data.labels[index] as string;
            this.selectedRowIndex = index;
            const clickedPoint =
              activePoint?.element?.tooltipPosition?.() ??
              { x: activePoint?.element?.x, y: activePoint?.element?.y };
            if (Number.isFinite(clickedPoint?.x) && Number.isFinite(clickedPoint?.y)) {
              this._lastTimelineCaret = { x: clickedPoint.x, y: clickedPoint.y };
            }

            this.logCount(this.newSessionData[index]);
            if (this.id && Array.isArray(this.id) && index >= 0 && index < this.id.length) {
              this.currentId = this.id[index];
            } else if (this.id) {
              this.currentId = this.id[index];
            }

            if (this.workingHoursStart && this.workingHoursEnd) {
              const insideData = this.newSessionData[index].filter(item => this.isInside(item.in, item.out));
              const outsideData = this.newSessionData[index].filter(item => !this.isInside(item.in, item.out));

              const logsDataInside: any = await this.groupJsonByAppName(insideData);
              if (logsDataInside) {
                this.inOutInside = logsDataInside.appUsageList.sort((a, b) => (a.totalUsage < b.totalUsage) ? 1 : -1);
                this.totalProductiveInside = logsDataInside.totalUsageHours;
                this.totalIdleInside = logsDataInside.totalIdleHours;
              } else {
                this.inOutInside = [];
                this.totalProductiveInside = '00 hrs 00 mins';
                this.totalIdleInside = '00 hrs 00 mins';
              }

              this.offlineInside = '00 hrs 00 mins';

              const logsDataOutside: any = await this.groupJsonByAppName(outsideData);
              if (logsDataOutside) {
                this.inOutOutside = logsDataOutside.appUsageList.sort((a, b) => (a.totalUsage < b.totalUsage) ? 1 : -1);
                this.totalProductiveOutside = logsDataOutside.totalUsageHours;
                this.totalIdleOutside = logsDataOutside.totalIdleHours;
              } else {
                this.inOutOutside = [];
                this.totalProductiveOutside = '00 hrs 00 mins';
                this.totalIdleOutside = '00 hrs 00 mins';
              }

              const totalOfflineAll = this.getOffLineCount(this.clockIn, this.clockOut, this.totalProductive, this.totalIdle);
              const totalOfflineAllSecs = this.durationToSeconds(totalOfflineAll);
              const totalProductiveSecs = this.durationToSeconds(this.totalProductive);
              const totalIdleSecs = this.durationToSeconds(this.totalIdle);
              const totalActiveSecs = totalProductiveSecs + totalIdleSecs;

              if (totalActiveSecs > 0) {
                const insideProductiveSecs = this.durationToSeconds(this.totalProductiveInside);
                const insideIdleSecs = this.durationToSeconds(this.totalIdleInside);
                const insideActiveSecs = insideProductiveSecs + insideIdleSecs;

                const outsideProductiveSecs = this.durationToSeconds(this.totalProductiveOutside);
                const outsideIdleSecs = this.durationToSeconds(this.totalIdleOutside);
                const outsideActiveSecs = outsideProductiveSecs + outsideIdleSecs;

                const insideRatio = insideActiveSecs / totalActiveSecs;
                const outsideRatio = outsideActiveSecs / totalActiveSecs;

                const insideOfflineSecs = Math.round(totalOfflineAllSecs * insideRatio);
                const outsideOfflineSecs = Math.round(totalOfflineAllSecs * outsideRatio);

                this.offlineInside = this.secondsToDuration(insideOfflineSecs);
                this.offlineOutside = this.secondsToDuration(outsideOfflineSecs);
              } else {
                this.offlineInside = totalOfflineAll;
                this.offlineOutside = '00 hrs 00 mins';
              }
            } else {
              const logsData: any = await this.groupJsonByAppName(this.newSessionData[index]);
              if (logsData) {
                logsData.appUsageList.sort((a, b) => (a.totalUsage < b.totalUsage) ? 1 : -1);
                this.inOut = logsData.appUsageList;
                this.totalAppUsageHours = logsData.totalUsageHours;
                this.totalIdleHours = logsData.totalIdleHours;
              }
            }
            this.hoverRowIndex = activePoint.index;
            this.chart.canvas.style.cursor = 'pointer';
            requestAnimationFrame(() => this.repositionTooltipsAfterScrollOrResize());
            return;
          }

          if (this.type !== 'horizontal') {
            // v4: for vertical bar charts use getElementsAtEventForMode
            const elements = this.chart.getElementsAtEventForMode(evt, 'nearest', { intersect: true }, false);
            const activePoint = elements[0];

            if (!activePoint) {
              // Clicked on empty canvas — close tooltip
              this.clearTooltipData();
            } else {
              const index = activePoint.index;
              const logsData = this.calculateEmployeeHours(this.totalWorkingArray);
              const singleUserLogs = logsData[index];
              this.index = index;

              if (singleUserLogs) {
                this.singleDayLog = null;
                for (const key in singleUserLogs) {
                  this.singleDayLog = singleUserLogs[key];
                  const workingTime = this.singleDayLog.working.split(':');
                  const idleTime = this.singleDayLog.idle.split(':');
                  const productiveTime = this.singleDayLog.productive.split(':');
                  const offlineTime = this.singleDayLog.offline.split(':');
                  this.singleDayLog['displayProductive'] = productiveTime[0] + " hrs " + productiveTime[1] + " mins";
                  this.singleDayLog['displayWorking'] = workingTime[0] + " hrs " + workingTime[1] + " mins";
                  this.singleDayLog['displayIdle'] = idleTime[0] + " hrs " + idleTime[1] + " mins";
                  this.singleDayLog['displayOffline'] = offlineTime[0] + " hrs " + offlineTime[1] + " mins";
                }
              } else {
                this.singleDayLog = null;
              }
            }
          }
        }),
        scales: {
          x: {
            min: isHorizontalChart ? ((ticks as any).min ?? 0.0) : undefined,
            max: isHorizontalChart ? ((ticks as any).max ?? 23.59) : undefined,
            beginAtZero: isHorizontalChart ? false : undefined,
            stacked: this.type !== 'horizontal' ? true : false,
            // Force one tick per hour for the horizontal timeline after Chart.js generates its set
            afterBuildTicks: isHorizontalChart ? (scale: any) => {
              const lo = Math.ceil(scale.min);
              const hi = Math.floor(scale.max);
              const forced: any[] = [];
              for (let h = lo; h <= hi; h++) {
                forced.push({ value: h });
              }
              scale.ticks = forced;
            } : undefined,
            ticks: {
              maxRotation: isHorizontalChart ? 0 : 0,
              minRotation: 0,
              font: {
                size: isHorizontalChart
                  ? 12
                  : 11,
                style: 'normal',
                weight: isHorizontalChart ? 'normal' : '500',
              },
              padding: isHorizontalChart ? 20 : 8,
              color: isHorizontalChart ? '#333' : '#64748b',
              stepSize: isHorizontalChart ? 1 : undefined,
              autoSkip: isHorizontalChart ? (window.innerWidth < 480) : false,
              align: isHorizontalChart ? undefined : 'center',
              maxTicksLimit: undefined,
              callback: function (value: any) {
                if (!isHorizontalChart) {
                  let label = typeof (this as any).getLabelForValue === 'function'
                    ? (this as any).getLabelForValue(value)
                    : value;
                  if (Array.isArray(label)) {
                    label = label[0];
                  }
                  if (typeof label === 'string') {
                    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                    const shortDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
                    const dayIndex = days.indexOf(label);
                    if (dayIndex !== -1) return shortDays[dayIndex];
                  }
                  return label;
                }
                if (typeof value == 'number') {
                  const hours = Math.floor(value);
                  const minutes = (value - hours) * 60;
                  const hoursString = hours.toString().padStart(2, '0');
                  const minutesString = Math.round(minutes).toString().padStart(2, '0');
                  const timeString = hoursString + ':' + minutesString;

                  if (isVirtualShift && startDate && endDate) {
                    if (hours < 24) {
                      return [timeString];
                    } else {
                      const actualHours = hours - 24;
                      const actualHoursString = actualHours.toString().padStart(2, '0');
                      return [actualHoursString + ':' + minutesString];
                    }
                  } else {
                    return [timeString];
                  }
                }
                return value;
              }
            },
            grid: {
              display: this.type !== 'horizontal' ? false : true,
              color: 'rgba(15, 23, 42, 0.08)',
              lineWidth: isHorizontalChart ? 2 : 1,
            },
            title: {
              display: isHorizontalChart,
              text: isVirtualShift ? '48-Hour Timeline' : 'Timeline',
              font: { weight: '600' },
            },
            offset: !isHorizontalChart,
            border: {
              display: this.type === 'horizontal',
            },
          },
          y: {
            grid: {
              display: this.type !== 'horizontal' ? true : false,
              color: 'rgba(15, 23, 42, 0.06)',
              drawTicks: false,
            },
            border: {
              display: false,
            },
            stacked: true,
            beginAtZero: !isHorizontalChart,
            grace: isHorizontalChart ? undefined : '8%',
            ticks: isHorizontalChart
              ? {
                autoSkip: false,
                font: { size: window.innerWidth < 768 ? 12 : 13 },
                padding: 10,
              }
              : {
                padding: 16,
                font: { size: 11 },
                color: '#94a3b8',
                crossAlign: 'near',
              },
          },
        },
      } as any,
      plugins: [{
        id: 'stackedChartDraw',
        beforeDatasetsDraw: (_chart: any) => { },
        afterDraw: (chart: any) => {
          const ctx = chart.ctx;
          // v4: scale IDs are 'x' and 'y'
          const xAxis = chart.scales['x'];
          const yAxis = chart.scales['y'];

          if (isVirtualShift && this.type == 'horizontal') {
            const x = xAxis.getPixelForValue(24);
            ctx.beginPath();
            ctx.moveTo(x, yAxis.top);
            ctx.lineTo(x, yAxis.bottom);
            ctx.lineWidth = 1;
            ctx.strokeStyle = '#0D47A1';
            ctx.setLineDash([5, 5]);
            ctx.stroke();
            ctx.setLineDash([]);
          }
          if (isVirtualShift) {
            this.drawVirtualShiftHeader(chart);
            this.drawEnhancedDateLabels(chart);
          }
          this.drawWorkingHours(chart);
          if (this.type === 'horizontal') {
            this.drawHorizontalRowEnhancements(chart);
            this.drawConductTimelogs(chart);
          }
        }
      }]
    } as any);

    this.applyHorizontalTimelineMinHeight();
    this.scheduleBarChartResize();
  }

  /** Chart.js sizes to its parent; flex/grid height often settles after the first paint. */
  private scheduleBarChartResize(): void {
    if (this.type !== 'bar' || !this.chart) {
      return;
    }
    const resize = () => {
      if (this.chart) {
        this.chart.resize();
      }
    };
    requestAnimationFrame(() => requestAnimationFrame(resize));
  }

  private drawHorizontalRowEnhancements(chart: any): void {
    const ctx = chart.ctx;
    const yAxis = chart.scales['y'];
    const chartArea = chart.chartArea;
    if (!yAxis || !chartArea) return;

    const rowGap = yAxis.ticks?.length > 1
      ? Math.abs(yAxis.getPixelForTick(1) - yAxis.getPixelForTick(0))
      : 32;
    const rowHeight = Math.max(22, rowGap * 0.72);

    const drawRowState = (rowIndex: number, fill: string, stroke: string, lineWidth: number) => {
      const yCenter = yAxis.getPixelForValue(rowIndex);
      const top = yCenter - rowHeight / 2;
      const radius = 8;
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(chartArea.left + radius, top);
      ctx.lineTo(chartArea.right - radius, top);
      ctx.quadraticCurveTo(chartArea.right, top, chartArea.right, top + radius);
      ctx.lineTo(chartArea.right, top + rowHeight - radius);
      ctx.quadraticCurveTo(chartArea.right, top + rowHeight, chartArea.right - radius, top + rowHeight);
      ctx.lineTo(chartArea.left + radius, top + rowHeight);
      ctx.quadraticCurveTo(chartArea.left, top + rowHeight, chartArea.left, top + rowHeight - radius);
      ctx.lineTo(chartArea.left, top + radius);
      ctx.quadraticCurveTo(chartArea.left, top, chartArea.left + radius, top);
      ctx.closePath();
      ctx.fillStyle = fill;
      ctx.fill();
      if (lineWidth > 0) {
        ctx.strokeStyle = stroke;
        ctx.lineWidth = lineWidth;
        ctx.stroke();
      }
      ctx.restore();
    };

    if (this.hoverRowIndex !== null && this.hoverRowIndex !== this.selectedRowIndex) {
      drawRowState(this.hoverRowIndex, 'rgba(71, 85, 105, 0.08)', 'transparent', 0);
    }
    if (this.selectedRowIndex !== null) {
      drawRowState(this.selectedRowIndex, 'rgba(59, 130, 246, 0.1)', 'rgba(59, 130, 246, 0.45)', 1);
    }

    ctx.save();
    ctx.textAlign = 'left';
    ctx.textBaseline = 'middle';
    ctx.font = '500 11px Inter, system-ui, sans-serif';
    const totalsX = chartArea.right + StackedChartComponent.HORIZONTAL_TOTALS_COLUMN_OFFSET;
    for (let i = 0; i < (this.newSessionData?.length || 0); i++) {
      const totals = this.getRowTotals(this.newSessionData[i]);
      const y = yAxis.getPixelForValue(i);
      ctx.fillStyle = '#0f172a';
      ctx.fillText(`A ${totals.active}`, totalsX, y - 7);
      ctx.fillStyle = '#475569';
      ctx.fillText(`I ${totals.idle}`, totalsX, y + 8);
    }
    ctx.restore();
  }

  getRowTotals(logs: any[] = []): { active: string; idle: string; offline: string } {
    if (!Array.isArray(logs) || !logs.length) {
      return { active: '0h 0m', idle: '0h 0m', offline: '0h 0m' };
    }
    let usageSeconds = 0;
    let idleSeconds = 0;
    const sortedLogs = this.sortLogsByStartTime(logs);
    sortedLogs.forEach((item: any) => {
      usageSeconds += this.hhmmssToSeconds(item?.usage);
      idleSeconds += this.hhmmssToSeconds(item?.idle);
    });
    const firstIn = new Date(sortedLogs[0]?.in).getTime();
    const lastOut = new Date(sortedLogs[sortedLogs.length - 1]?.out).getTime();
    const totalWindowSeconds = Number.isFinite(firstIn) && Number.isFinite(lastOut) && lastOut > firstIn
      ? Math.floor((lastOut - firstIn) / 1000)
      : usageSeconds + idleSeconds;
    const offlineSeconds = Math.max(0, totalWindowSeconds - usageSeconds - idleSeconds);
    return {
      active: this.secondsToCompactDuration(usageSeconds),
      idle: this.secondsToCompactDuration(idleSeconds),
      offline: this.secondsToCompactDuration(offlineSeconds),
    };
  }

  private hhmmssToSeconds(value: string): number {
    if (!value || typeof value !== 'string') return 0;
    const [h = 0, m = 0, sec = 0] = value.split(':').map((v) => Number(v) || 0);
    return h * 3600 + m * 60 + sec;
  }

  secondsToCompactDuration(seconds: number): string {
    const safeSeconds = Math.max(0, Math.floor(seconds || 0));
    const hrs = Math.floor(safeSeconds / 3600);
    const mins = Math.floor((safeSeconds % 3600) / 60);
    return `${hrs}h ${mins}m`;
  }

  calculateEmployeeHours(data) {
    let arr = [];
    for (let key in data) {
      let obj = {};
      obj[key] = data[key];
      arr.push(obj);
    }
    return arr
  }

  private sortLogsByStartTime(logs: any[]): any[] {
    if (!Array.isArray(logs)) {
      return [];
    }
    return [...logs].sort((a: any, b: any) => {
      const aTime = new Date(a?.in).getTime();
      const bTime = new Date(b?.in).getTime();
      return aTime - bTime;
    });
  }

  logCount(logs) {
    let totalUsageSeconds = 0;
    let totalIdleSeconds = 0;
    const sortedLogs = this.sortLogsByStartTime(logs);

    if (sortedLogs && sortedLogs.length) {
      for (let i = 0; i < sortedLogs.length; i++) {
        if (i === 0) this.clockIn = sortedLogs[0].in

        if (i === (sortedLogs.length - 1)) {
          this.clockOut = sortedLogs[sortedLogs.length - 1].out
        }
        const usageTimeParts = sortedLogs[i].usage.split(':');
        const idleTimeParts = sortedLogs[i].idle.split(':');

        // Convert hours, minutes, and seconds into seconds
        const usageSeconds = parseInt(usageTimeParts[0]) * 3600 + parseInt(usageTimeParts[1]) * 60 + parseInt(usageTimeParts[2]);
        const idleSeconds = parseInt(idleTimeParts[0]) * 3600 + parseInt(idleTimeParts[1]) * 60 + parseInt(idleTimeParts[2]);

        // Accumulate the seconds
        if (sortedLogs[i].appName != '') {
          totalUsageSeconds += usageSeconds;
          totalIdleSeconds += idleSeconds;
        }
      }

      // Convert total seconds back to hours, minutes, and seconds
      let totalUsageHours = Math.floor(totalUsageSeconds / 3600);
      const totalUsageMinutes = Math.floor((totalUsageSeconds % 3600) / 60);
      const totalUsageSecondsRemainder = totalUsageSeconds % 60;

      const totalIdleHours = Math.floor(totalIdleSeconds / 3600);
      const totalIdleMinutes = Math.floor((totalIdleSeconds % 3600) / 60);

      this.totalProductive = `${totalUsageHours < 10 ? '0' + totalUsageHours : totalUsageHours} ${totalUsageHours === 1 ? 'hr' : 'hrs'} ${totalUsageMinutes < 10 ? '0' + totalUsageMinutes : totalUsageMinutes} ${totalUsageMinutes === 1 ? 'min' : 'mins'}`;
      this.totalIdle = `${totalIdleHours < 10 ? '0' + totalIdleHours : totalIdleHours} ${totalIdleHours === 1 ? 'hr' : 'hrs'} ${totalIdleMinutes < 10 ? '0' + totalIdleMinutes : totalIdleMinutes} ${totalIdleMinutes === 1 ? 'min' : 'mins'}`;

    } else {
      this.totalProductive = '00hr 00min';
    }

  }
  async calculateHours(logs) {
    let totalUsageSeconds = 0;
    let totalIdleSeconds = 0;
    let finalObj = {}
    const sortedLogs = this.sortLogsByStartTime(logs);
    if (sortedLogs && sortedLogs.length) {
      const logsLength = sortedLogs.length

      const appNameUsageCounts = {};
      for (let i = 0; i <= logsLength - 1; i++) {
        if (i === 0) this.clockIn = sortedLogs[0].in
        if (i === (logsLength - 1)) {
          this.clockOut = sortedLogs[sortedLogs.length - 1].out
        }

        let obj = sortedLogs[i]
        const appName = obj.appName;
        const usage = obj.usage;

        const usageTimeParts = obj.usage.split(':');
        const idleTimeParts = obj.idle.split(':');

        // Convert hours, minutes, and seconds into seconds
        const usageSeconds = parseInt(usageTimeParts[0]) * 3600 + parseInt(usageTimeParts[1]) * 60 + parseInt(usageTimeParts[2]);
        const idleSeconds = parseInt(idleTimeParts[0]) * 3600 + parseInt(idleTimeParts[1]) * 60 + parseInt(idleTimeParts[2]);

        // Accumulate the seconds
        if (appName != '') {
          totalUsageSeconds += usageSeconds;
          totalIdleSeconds += idleSeconds;
        }

        if (appName in appNameUsageCounts) {
          appNameUsageCounts[appName] += await this.timeToMilliseconds(usage);
        } else {
          appNameUsageCounts[appName] = await this.timeToMilliseconds(usage);
        }
      }

      // Convert total seconds back to hours, minutes, and seconds
      let totalUsageHours = Math.floor(totalUsageSeconds / 3600);
      const totalUsageMinutes = Math.floor((totalUsageSeconds % 3600) / 60);
      const totalUsageSecondsRemainder = totalUsageSeconds % 60;

      const totalIdleHours = Math.floor(totalIdleSeconds / 3600);
      const totalIdleMinutes = Math.floor((totalIdleSeconds % 3600) / 60);
      const totalIdleSecondsRemainder = totalIdleSeconds % 60;

      // Convert the appNameUsageCounts object to an array of objects
      const resultArray = Object.keys(appNameUsageCounts).map(appName => ({
        appName: appName,
        totalUsage: this.millisecondsToHours(appNameUsageCounts[appName])
      }));

      finalObj['appUsageList'] = resultArray
      finalObj['totalUsageHours'] = `${totalUsageHours} ${totalUsageHours <= 1 ? 'hr' : 'hrs'} ${totalUsageMinutes} ${totalUsageMinutes <= 1 ? 'min' : 'mins'}`;
      finalObj['totalIdleHours'] = `${totalIdleHours} ${totalIdleHours <= 1 ? 'hr' : 'hrs'} ${totalIdleMinutes} ${totalIdleMinutes <= 1 ? 'min' : 'mins'}`;;
      return finalObj
    }
    return finalObj;


  }

  // Function to convert "hh:mm:ss" to milliseconds
  timeToMilliseconds(timeString) {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    const totalMilliseconds = hours * 3600000 + minutes * 60000 + seconds * 1000;
    return totalMilliseconds;
  }


  // Function to convert milliseconds to hours as a string in "hh:mm:ss" format
  millisecondsToHours(milliseconds) {
    const hours = Math.floor(milliseconds / 3600000);
    const minutes = Math.floor((milliseconds % 3600000) / 60000);
    const seconds = Math.floor((milliseconds % 60000) / 1000);
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  timeSlotEdit(event: any, array: any) {
    const elements = this.chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, false);
    if (!elements.length) return;
    const activePoint = elements[0];
    const datasetIndex = activePoint.datasetIndex;
    const label = this.chart.data.datasets[datasetIndex].label;
    const value = this.chart.data.datasets[datasetIndex].data[activePoint.index];
  }

  updateChartMustErrors(error) {
    const sessionData = [
      {
        label: `${error.error.message}`,
        data: [], // Replaced
        backgroundColor: '',
        borderColor: '',
        borderWidth: 0,
        barThickness: 40
      },
      {
        label: `${error.error.message}`,
        data: [], // Replaced
        backgroundColor: '',
        borderColor: '',
        borderWidth: 0,
        barThickness: 40,
      },
    ];
    this.chart.data.labels = [];
    this.chart.data.datasets = sessionData;
    this.chart.update();
  }

  openModalHoursLogs(date: any) {
    if (this.totalWorkingArr) {
      let correctSessions = this._sharedService.gettingTheCorrectSession(this.totalWorkingArr[date].sessions);
      let type = "timeLog";
      let data: any = {};
      data.date = date;
      data.working_hours = this.totalWorkingArr[date].working;
      data.timeLog = correctSessions;
      data.type = type;
      this.dialog.open(LogsDisplayModalComponent, {
        width: type !== "appInfo" ? "1000px" : "750px",
        maxHeight: "calc(100vh - 90px)",
        height: "auto",
        data: {
          date: date,
          working_hours: this.totalWorkingArr[date].working,
          timeLog: correctSessions,
          type: type,
        },
      });
    }
  }

  makeDataForChartTicks(data: any, type: any) {
    if (type == "horizontal") {
      let arr = [];
      data.forEach((element) => {
        let minVal: any = Math.min(...element.data);
        arr.push(minVal);
      });
      return Math.min(...arr);
    }
    else {
      let arr = [];
      data.forEach((element) => {
        let minVal: any = Math.min(...element.data);
        arr.push(minVal);
      });
      return Math.floor(Math.min(...arr));
    }
  }

  timeToNumber(timeString) {

    // Split the time string into hours, minutes, and seconds
    var timeParts = timeString.split(":");
    var hours = parseInt(timeParts[0]);
    var minutes = parseInt(timeParts[1]);

    // Calculate the decimal representation
    var decimalValue = hours + minutes / 60;

    // Round the decimal value to two decimal places
    decimalValue = Math.round(decimalValue * 100) / 100;
    return decimalValue;
  }

  showCustomTooltip(event: MouseEvent, content: string) {
    const tooltip: HTMLElement = this.app_usage_tooltip_horizontal1?.nativeElement;
    if (!tooltip) return;
    tooltip.style.display = "block";
    tooltip.style.opacity = '1';
    tooltip.style.left = event.clientX + 'px';
    tooltip.style.top = event.clientY + 'px';
    const sanitizedContent = this.sanitization.sanitizeHtml(content);
    tooltip.innerHTML = sanitizedContent as string;
  }


  handleButtonClick(inOut) {
    // Handle button click here

    // Open Application Analysis modal from here
    let type = "timeline";

    this.dialog.open(LogsDisplayModalComponent, {
      width: type !== "timeline" ? "1000px" : "calc(100vw - 20vw)",
      maxHeight: "calc(100vh - 90px)",
      height: "auto",
      data: {
        type: type,
        appInfo: inOut.details,
        in: inOut.in,
        out: inOut.out
      },
    });
  }

  closeTooltip() {
    this.selectedRowIndex = null;
    this.hoverRowIndex = null;
  }

  closeBarChartTooltip() {
    const tooltipEl: HTMLElement = this.tooltipBarChart1?.nativeElement;
    if (tooltipEl) {
      tooltipEl.style.display = 'none';
    }
  }

  clearTooltipData() {
    this._lastTimelineCaret = { x: 0, y: 0 };
    this._lastBarCaret = { x: 0, y: 0 };
    // Hide all tooltips
    const tooltipBarChart: HTMLElement = this.tooltipBarChart1?.nativeElement;
    if (tooltipBarChart) {
      tooltipBarChart.style.display = 'none';
    }

    // Reset tooltip data properties
    this.hoveredConductTask = null;
    this.hoveredSuperSeeTimeRange = '';
    this.hoveredSuperSeeDuration = '';
    this.hoveredConductTimeDifferenceSecs = 0;
    this.hoveredConductTimeDifference = '';
    this.singleDayLog = null;
    this.userName = null;
    this.inOut = [];
    this.inOutInside = [];
    this.inOutOutside = [];
    this.totalProductive = '00hrs 00min';
    this.totalIdle = '00hrs 00min';
    this.totalProductiveInside = '00hrs 00min';
    this.totalIdleInside = '00hrs 00min';
    this.offlineInside = '00hrs 00min';
    this.totalProductiveOutside = '00hrs 00min';
    this.totalIdleOutside = '00hrs 00min';
    this.offlineOutside = '00hrs 00min';
    this.clockIn = null;
    this.clockOut = null;
    this.totalAppUsageHours = null;
    this.totalIdleHours = null;
    this.tooltipTitle = null;
    this.tooltipContent = null;
    this.tooltipTime = null;
    this.hoverIndexval = null;
    this.hoverRowIndex = null;
    this.selectedRowIndex = null;
    this.currentId = null;
  }

  reattachTooltipHandlers() {
    if (!this.chart) return;

    // v4: tooltip config lives under options.plugins.tooltip
    const tooltipPlugin = (this.chart.options as any)?.plugins?.tooltip;
    if (tooltipPlugin) {
      if (this.type !== 'horizontal') {
        tooltipPlugin.external = (context: any) => {
          const { chart, tooltip } = context;
          const tooltipEl: any = this.tooltipBarChart1?.nativeElement;
          const dataPoints: any = tooltip.dataPoints;

          if (dataPoints && dataPoints.length > 0) {
            this.hoverIndexval = dataPoints[0].dataIndex;
            const val = dataPoints[0].parsed?.y ?? 0;
            const hours = Math.floor(val);
            const minutes = Math.floor((val - hours) * 60);
            const seconds = Math.floor(((val - hours) * 60 - minutes) * 60);

            const timeFunCalls = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
            this.tooltipTitle = dataPoints[0].label;
            if (dataPoints[0].datasetIndex == 1) {
              this.tooltipContent = "Active Hours";
              this.tooltipTime = timeFunCalls;
            } else {
              this.tooltipContent = "Idle Hours";
              this.tooltipTime = timeFunCalls;
            }
          }

          if (!dataPoints) {
            this._lastBarCaret = { x: 0, y: 0 };
            tooltipEl.style.display = 'none';
          } else {
            tooltipEl.style.display = 'block';
          }

          if (dataPoints && tooltipEl) {
            this._lastBarCaret = { x: tooltip.caretX, y: tooltip.caretY };
            this.applyVerticalBarTooltipPosition(chart, tooltip.caretX, tooltip.caretY);
          }
        };
      } else {
        tooltipPlugin.external = (context: any) => {
          const { chart, tooltip } = context;
          const dataPoints: any = tooltip.dataPoints;

          if (!dataPoints) {
            this._lastTimelineCaret = { x: 0, y: 0 };
            return;
          }
          if (this.selectedRowIndex !== null) {
            // Keep tooltip anchored to clicked row while open.
            this.applyHorizontalAppUsageTooltipPosition(
              chart,
              this._lastTimelineCaret.x,
              this._lastTimelineCaret.y
            );
            return;
          }
        };
      }
    }
  }

  groupJsonByAppName(data) {
    let groupedData = {};
    // Iterate over each entry in the JSON data
    data.forEach(entry => {
      let { appName, usage, idle } = entry;

      // If the app name doesn't exist in the groupedData object, create it
      if (!groupedData[appName]) {
        groupedData[appName] = {
          totalUsage: '00:00:00',
          totalIdle: '00:00:00'
        };
      }

      // Add the usage and idle time of the current entry to the corresponding app
      groupedData[appName].totalUsage = this.addTimes(groupedData[appName].totalUsage, usage);
      groupedData[appName].totalIdle = this.addTimes(groupedData[appName].totalIdle, idle);
    });

    // Convert groupedData to the desired output format
    let appUsageList = [];
    let totalUsage = '00:00:00';
    let totalIdle = '00:00:00';

    for (let appName in groupedData) {
      let { totalUsage: appTotalUsage, totalIdle: appTotalIdle } = groupedData[appName];
      appUsageList.push({ appName, totalUsage: appTotalUsage });

      totalUsage = this.addTimes(totalUsage, appTotalUsage);
      totalIdle = this.addTimes(totalIdle, appTotalIdle);
    }

    // Calculate total usage and idle hours
    let totalUsageHours = this.calculateHoursCount(totalUsage);
    let totalIdleHours = this.calculateHoursCount(totalIdle);

    return { appUsageList, totalUsageHours, totalIdleHours };
  }
  calculateHoursCount(time) {
    let [hours, minutes] = time.split(':').map(Number);
    return `${hours} hrs ${minutes} mins`;
  }
  // Function to add two time durations in HH:mm:ss format
  addTimes(time1, time2) {
    let [h1, m1, s1] = time1.split(':').map(Number);
    let [h2, m2, s2] = time2.split(':').map(Number);

    let totalSeconds = s1 + s2;
    let carryMinutes = Math.floor(totalSeconds / 60);
    let seconds = totalSeconds % 60;

    let totalMinutes = m1 + m2 + carryMinutes;
    let carryHours = Math.floor(totalMinutes / 60);
    let minutes = totalMinutes % 60;

    let hours = h1 + h2 + carryHours;

    return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
  }

  // Function to pad single-digit numbers with a leading zero
  pad(num) {
    return num.toString().padStart(2, '0');
  }

  isInside(itemStartTimeStr: string, itemEndTimeStr: string): boolean {
    if (!this.workingHoursStart || !this.workingHoursEnd) {
      return false;
    }

    const shiftStart = this.timeToNumber(this.workingHoursStart);
    const shiftEnd = this.timeToNumber(this.workingHoursEnd);

    const itemStart = new Date(itemStartTimeStr);
    const itemEnd = new Date(itemEndTimeStr);

    const isVirtualShift = this.isVirtualShiftEnabled();
    const isOvernightShift = shiftStart > shiftEnd;

    // Function to check overlap for a given day
    const checkOverlap = (dayOffset: number): boolean => {
      const chartStartDate = new Date(this.startDate);
      chartStartDate.setHours(0, 0, 0, 0);

      const dayStart = new Date(chartStartDate);
      dayStart.setDate(chartStartDate.getDate() + dayOffset);

      if (isOvernightShift) {
        // For overnight shifts, we need to check if the item falls within the shift hours
        // which spans from shiftStart to shiftEnd of the next day

        // Create shift boundaries for this day
        const shiftStartTime = new Date(dayStart);
        shiftStartTime.setHours(Math.floor(shiftStart), (shiftStart % 1) * 60, 0, 0);

        const shiftEndTime = new Date(dayStart);
        shiftEndTime.setDate(dayStart.getDate() + 1); // Next day
        shiftEndTime.setHours(Math.floor(shiftEnd), (shiftEnd % 1) * 60, 0, 0);

        // For overnight shifts, also check the previous day's shift that ends on this day
        const prevDayShiftStart = new Date(dayStart);
        prevDayShiftStart.setDate(dayStart.getDate() - 1);
        prevDayShiftStart.setHours(Math.floor(shiftStart), (shiftStart % 1) * 60, 0, 0);

        const prevDayShiftEnd = new Date(dayStart);
        prevDayShiftEnd.setHours(Math.floor(shiftEnd), (shiftEnd % 1) * 60, 0, 0);

        // Check if item overlaps with current day's shift (starts today, ends tomorrow)
        const currentShiftOverlap = itemStart < shiftEndTime && itemEnd > shiftStartTime;

        // Check if item overlaps with previous day's shift (started yesterday, ends today)
        const prevShiftOverlap = itemStart < prevDayShiftEnd && itemEnd > prevDayShiftStart;

        return currentShiftOverlap || prevShiftOverlap;
      } else {
        // Normal shift - same day start and end
        const dayShiftStart = new Date(dayStart);
        dayShiftStart.setHours(Math.floor(shiftStart), (shiftStart % 1) * 60, 0, 0);

        const dayShiftEnd = new Date(dayStart);
        dayShiftEnd.setHours(Math.floor(shiftEnd), (shiftEnd % 1) * 60, 0, 0);

        // Check for overlap: (StartA < EndB) and (EndA > StartB)
        return itemStart < dayShiftEnd && itemEnd > dayShiftStart;
      }
    };

    if (checkOverlap(0)) {
      return true;
    }

    if (isVirtualShift && checkOverlap(1)) {
      return true;
    }

    return false;
  }


  durationToSeconds(durationStr: string): number {
    const [hrs, mins] = durationStr.match(/\d+/g)?.map(Number) ?? [0, 0];
    return (hrs * 60 + mins) * 60;
  }

  secondsToDuration(seconds: number): string {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    return `${hrs.toString().padStart(2, '0')} hrs ${mins.toString().padStart(2, '0')} mins`;
  }

  getOffLineCount(
    clockIn: string | Date,
    clockOut: string | Date,
    totalProductive: string,
    totalIdle: string
  ): string {
    if (!clockIn || !clockOut) return this.secondsToDuration(0);

    const startTime = new Date(clockIn).getTime();
    const endTime = new Date(clockOut).getTime();
    const totalDurationSec = Math.floor((endTime - startTime) / 1000);

    const productiveSec = this.durationToSeconds(totalProductive);
    const idleSec = this.durationToSeconds(totalIdle);

    const offlineSec = totalDurationSec - productiveSec - idleSec;
    return this.secondsToDuration(Math.max(offlineSec, 0));
  }

  getActivityMix(): { active: number; idle: number; offline: number } {
    const active = this.durationToSeconds(this.totalProductive);
    const idle = this.durationToSeconds(this.totalIdle);
    const offline = this.durationToSeconds(
      this.getOffLineCount(this.clockIn, this.clockOut, this.totalProductive, this.totalIdle)
    );
    const total = active + idle + offline;

    if (!total) {
      return { active: 0, idle: 0, offline: 0 };
    }

    return {
      active: Math.round((active / total) * 100),
      idle: Math.round((idle / total) * 100),
      offline: Math.round((offline / total) * 100),
    };
  }

  getTrackedWindowDuration(): string {
    if (!this.clockIn || !this.clockOut) return '00 hrs 00 mins';
    const startTime = new Date(this.clockIn).getTime();
    const endTime = new Date(this.clockOut).getTime();
    const totalDurationSec = Math.max(Math.floor((endTime - startTime) / 1000), 0);
    return this.secondsToDuration(totalDurationSec);
  }

  getTopApplicationInsight(): { appName: string; totalUsage: string } | null {
    const primarySource = (this.workingHoursStart && this.workingHoursEnd)
      ? [...(this.inOutInside || []), ...(this.inOutOutside || [])]
      : (this.inOut || []);

    if (!Array.isArray(primarySource) || !primarySource.length) {
      return null;
    }

    const mergedUsage = new Map<string, number>();

    primarySource.forEach((item: any) => {
      if (!item?.appName || !item?.totalUsage) return;
      const existing = mergedUsage.get(item.appName) || 0;
      mergedUsage.set(item.appName, existing + this.hhmmssToSeconds(item.totalUsage));
    });

    let best: { appName: string; totalUsage: string } | null = null;
    let maxSeconds = -1;

    mergedUsage.forEach((seconds, appName) => {
      if (seconds > maxSeconds) {
        maxSeconds = seconds;
        best = { appName, totalUsage: this.secondsToHhmmss(seconds) };
      }
    });

    return best;
  }

  private secondsToHhmmss(seconds: number): string {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${this.pad(h)}:${this.pad(m)}:${this.pad(s)}`;
  }

  drawVirtualShiftHeader(chart) {
    const ctx = chart.ctx;
    const xAxis = chart.scales['x'];
    const chartArea = chart.chartArea;

    const headerY = 0;
    const headerHeight = 50;

    // Day 1 Box
    const xStart = xAxis.left;
    const xMid = xAxis.getPixelForValue(24);
    ctx.fillStyle = 'rgba(227, 242, 253, 0.7)';
    ctx.fillRect(xStart, headerY, xMid - xStart, headerHeight);

    // Day 2 Box
    const xEnd = xAxis.right;
    ctx.fillStyle = 'rgba(243, 229, 245, 0.7)';
    ctx.fillRect(xMid, headerY, xEnd - xMid, headerHeight);

    const startMoment = new Date(this.startDate);
    const endMoment = new Date(this.endDate);
    const day1Label = startMoment.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    const day2Label = endMoment.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

    ctx.save();
    ctx.font = '600 12px sans-serif';
    ctx.textAlign = 'center';

    // Day 1 Text
    const day1x = (xStart + xMid) / 2;
    const textY = headerY + 20;
    ctx.fillStyle = '#1976d2';
    ctx.fillText('DAY 1: ' + day1Label, day1x, textY);
    ctx.fillStyle = '#666';
    ctx.font = '11px sans-serif';
    ctx.fillText('00:00 - 23:59', day1x, textY + 15);

    // Day 2 Text
    const day2x = (xMid + xEnd) / 2;
    ctx.fillStyle = '#7b1fa2';
    ctx.font = '600 12px sans-serif';
    ctx.fillText('DAY 2: ' + day2Label, day2x, textY);
    ctx.fillStyle = '#666';
    ctx.font = '11px sans-serif';
    ctx.fillText('00:00 - 23:59', day2x, textY + 15);

    // Timeline Title
    const titleX = xMid;
    const titleY = textY + 30;
    ctx.fillStyle = '#888';
    ctx.font = '10px sans-serif';
    ctx.fillText('48-Hour Virtual Shift Timeline', titleX, titleY);

    ctx.restore();
  }

  drawWorkingHours(chart) {
    if (this.type !== 'horizontal') {
      return;
    }
    const isVirtualShift = this.isVirtualShiftEnabled();
    if (!this.workingHoursStart || !this.workingHoursEnd) {
      return;
    }

    const start = this.timeToNumber(this.workingHoursStart);
    const end = this.timeToNumber(this.workingHoursEnd);
    const ctx = chart.ctx;
    const xAxis = chart.scales['x'];
    const yAxis = chart.scales['y'];
    const chartArea = chart.chartArea;
    const visibleMin = Number.isFinite(xAxis?.min) ? xAxis.min : 0;
    const visibleMax = Number.isFinite(xAxis?.max) ? xAxis.max : (isVirtualShift ? 48 : 24);

    const backgroundColor = 'rgba(75, 192, 192, 0.2)';
    const borderColor = 'rgba(75, 192, 192, 1)';
    const borderWidth = 1;

    const drawBox = (min, max) => {
      const clampedMin = Math.max(visibleMin, Math.min(min, visibleMax));
      const clampedMax = Math.max(visibleMin, Math.min(max, visibleMax));
      if (clampedMax <= clampedMin) {
        return;
      }

      const xStart = xAxis.getPixelForValue(clampedMin);
      const xEnd = xAxis.getPixelForValue(clampedMax);
      const safeLeft = Math.max(chartArea.left, Math.min(xStart, xEnd));
      const safeRight = Math.min(chartArea.right, Math.max(xStart, xEnd));
      const width = safeRight - safeLeft;
      if (width <= 0) {
        return;
      }

      ctx.fillRect(safeLeft, yAxis.top, width, yAxis.height);
      ctx.strokeRect(safeLeft, yAxis.top, width, yAxis.height);
    };

    ctx.save();
    ctx.fillStyle = backgroundColor;
    ctx.strokeStyle = borderColor;
    ctx.lineWidth = borderWidth;

    if (start > end) { // Overnight shift

      if (!isVirtualShift) {
        drawBox(0, end)
        drawBox(start, 24);
      } else {
        // Day 1: From midnight to end time
        drawBox(0, end);
        // Day 1: From start time to end of day (24 hours)
        drawBox(start, 24);
        // Day 2: From midnight to end time  
        drawBox(24, 24 + end);
        // Day 2: From start time to end of day (48 hours)
        drawBox(start + 24, 48);
      }
    } else { // Normal shift
      drawBox(start, end);
      if (isVirtualShift) {
        drawBox(start + 24, end + 24);
      }
    }
    ctx.restore();
  }

  drawEnhancedDateLabels(chart) {
    const ctx = chart.ctx;
    const xAxis = chart.scales['x'];
    const yAxis = chart.scales['y'];

    // Draw date labels below the x-axis for better clarity
    const startMoment = new Date(this.startDate);
    const endMoment = new Date(this.endDate);
    const day1Label = startMoment.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    const day2Label = endMoment.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

    ctx.save();
    ctx.font = 'bold 14px sans-serif';
    ctx.textAlign = 'center';
    ctx.fillStyle = '#333';

    // Position labels closer to the x-axis time labels for better association
    const labelY = yAxis.bottom + 25; // Moved closer to x-axis

    // Day 1 label (left half) - positioned under the first 12 hours
    const day1x = (xAxis.left + xAxis.getPixelForValue(24)) / 2;
    ctx.fillStyle = '#1976d2';
    ctx.fillText(day1Label, day1x, labelY);

    // Day 2 label (right half) - positioned under the second 12 hours
    const day2x = (xAxis.getPixelForValue(24) + xAxis.right) / 2;
    ctx.fillStyle = '#7b1fa2';
    ctx.fillText(day2Label, day2x, labelY);

    // Add a subtle separator line at the 24-hour mark
    const separatorX = xAxis.getPixelForValue(24);
    ctx.beginPath();
    ctx.moveTo(separatorX, labelY - 15);
    ctx.lineTo(separatorX, labelY + 10);
    ctx.strokeStyle = '#ccc';
    ctx.lineWidth = 1;
    ctx.stroke();

    ctx.restore();
  }

  drawConductTimelogs(chart: any): void {
    if (this.type !== 'horizontal' || !Array.isArray(this.conductTimelogs) || !this.conductTimelogs.length) {
      return;
    }
    const ctx: CanvasRenderingContext2D = chart.ctx;
    const xAxis = chart.scales['x'];
    const yAxis = chart.scales['y'];
    const chartArea = chart.chartArea;
    if (!ctx || !xAxis || !yAxis || !chartArea) return;

    this.renderedConductPills = [];
    const isVirtualShift = this.isVirtualShiftEnabled();

    for (let rowIndex = 0; rowIndex < (this.labels?.length || 0); rowIndex++) {
      const rowLabel = this.labels[rowIndex];
      if (!rowLabel) continue;

      const rowMoment = moment(rowLabel, ['MMM DD, YYYY', 'MMM D, YYYY', 'YYYY-MM-DD', 'MM/DD/YYYY', 'YYYY/MM/DD']);
      const isDateRow = rowMoment.isValid() && (/\d{4}/.test(rowLabel) || /Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec/i.test(rowLabel));
      const rowDateStr = isDateRow ? rowMoment.format('YYYY-MM-DD') : '';
      const rowUserId = Array.isArray(this.id) ? this.id[rowIndex] : this.id;

      // Filter conduct timelogs for this specific row
      const dayLogs = this.conductTimelogs.filter((l) => {
        const rawLogDate = l.log_date || l.date;
        const logDateMom = rawLogDate ? moment(rawLogDate, ['YYYY-MM-DD', 'MMM DD, YYYY', 'MMM D, YYYY', 'YYYY/MM/DD', 'MM/DD/YYYY']) : null;
        const logDateStr = logDateMom && logDateMom.isValid() ? logDateMom.format('YYYY-MM-DD') : '';

        // Case 1: Single-employee drilldown where each row is a calendar date
        if (rowDateStr) {
          return Boolean(logDateStr && logDateStr === rowDateStr);
        }

        // Case 2: Multi-employee dashboard timeline where each row is an employee
        const matchesUser =
          (rowUserId != null && String(l.supersee_user_id || l.supersee_user) === String(rowUserId)) ||
          (Boolean(l.employee_name) && l.employee_name === rowLabel);
        if (!matchesUser) {
          return false;
        }

        // Validate that the log's date matches the active chart date (or 48h range)
        if (logDateStr && this.startDate) {
          const chartStartDay = moment(this.startDate).format('YYYY-MM-DD');
          if (isVirtualShift && this.endDate) {
            const chartEndDay = moment(this.endDate).format('YYYY-MM-DD');
            return logDateStr === chartStartDay || logDateStr === chartEndDay;
          }
          return logDateStr === chartStartDay;
        }

        return true;
      });

      if (!dayLogs.length) continue;

      dayLogs.sort((a, b) => this.parseLogStartMinute(a) - this.parseLogStartMinute(b));

      const rowYCenter = yAxis.getPixelForValue(rowIndex);
      const totalDayTasks = dayLogs.length;

      dayLogs.forEach((log, logIdx) => {
        const startMin = this.parseLogStartMinute(log);
        let endMin = this.parseLogEndMinute(log, startMin);
        if (endMin <= startMin) {
          endMin = startMin + 30;
        }

        const startDec = startMin / 60;
        const endDec = endMin / 60;

        let renderStartDec = startDec;
        let renderEndDec = endDec;
        if (isVirtualShift && this.isLogOnDay2(log)) {
          renderStartDec += 24;
          renderEndDec += 24;
        }

        const xStart = Math.max(chartArea.left, Math.min(chartArea.right, xAxis.getPixelForValue(renderStartDec)));
        const xEnd = Math.max(chartArea.left, Math.min(chartArea.right, xAxis.getPixelForValue(renderEndDec)));
        if (xEnd <= xStart) return;

        const overlapDetails = this.calculateSuperSeeActiveOverlapDetails(rowIndex, startMin, endMin);
        const activeOverlapText = overlapDetails.activeText || this.formatActiveOverlapDisplay(overlapDetails.activeSecs);
        const timeRangeText = `${this.minutesTo12h(startMin)} – ${this.minutesTo12h(endMin)}`;
        const durSecs = this.getConductLogDurationSeconds(log, (endMin - startMin) * 60);
        const durationText = this.formatDurationHhMmDisplay(durSecs);
        const differenceSecs = Math.max(0, durSecs - overlapDetails.activeSecs);
        const differenceText = differenceSecs > 0 ? this.formatDurationHhMmDisplay(differenceSecs) : '';
        const idleSecs = overlapDetails.idleSecs || 0;
        const offlineSecs = overlapDetails.offlineSecs || 0;
        const idleText = overlapDetails.idleText || this.formatActiveOverlapDisplay(idleSecs);
        const offlineText = overlapDetails.offlineText || this.formatActiveOverlapDisplay(offlineSecs);

        const hasOverlap = dayLogs.some((other, oIdx) => {
          if (oIdx === logIdx) return false;
          const oStart = this.parseLogStartMinute(other);
          const oEnd = this.parseLogEndMinute(other, oStart);
          return Math.max(startMin, oStart) < Math.min(endMin, oEnd);
        });

        const yOffset = hasOverlap ? (logIdx % 2 === 0 ? -4 : 4) : 0;
        const yCenter = rowYCenter + yOffset;
        const logColor = this.getConductLogColor(log);

        // Draw Whisker Brackets (|-- and --|)
        const whiskerHeight = 20;
        ctx.save();
        ctx.strokeStyle = logColor;
        ctx.lineWidth = 1.5;

        // Start tick |
        ctx.beginPath();
        ctx.moveTo(xStart, yCenter - whiskerHeight / 2);
        ctx.lineTo(xStart, yCenter + whiskerHeight / 2);
        ctx.stroke();

        // End tick |
        ctx.beginPath();
        ctx.moveTo(xEnd, yCenter - whiskerHeight / 2);
        ctx.lineTo(xEnd, yCenter + whiskerHeight / 2);
        ctx.stroke();

        // Whisker line
        ctx.beginPath();
        ctx.moveTo(xStart, yCenter);
        ctx.lineTo(xEnd, yCenter);
        ctx.stroke();

        // Draw Capsule Pill
        const totalW = xEnd - xStart;
        const pillW = Math.max(16, totalW - 6);
        const pillLeft = xStart + 3;
        const pillTop = yCenter - 9;
        const pillHeight = 18;
        const pillRadius = 9;

        const isHovered = this.hoveredConductTask === log;

        if (isHovered) {
          ctx.shadowColor = logColor;
          ctx.shadowBlur = 8;
        }

        ctx.beginPath();
        if (typeof (ctx as any).roundRect === 'function') {
          (ctx as any).roundRect(pillLeft, pillTop, pillW, pillHeight, pillRadius);
        } else {
          this.drawFallbackRoundRect(ctx, pillLeft, pillTop, pillW, pillHeight, pillRadius);
        }
        ctx.fillStyle = logColor;
        ctx.fill();

        ctx.strokeStyle = isHovered ? '#ffffff' : 'rgba(255, 255, 255, 0.9)';
        ctx.lineWidth = 1.5;
        ctx.stroke();
        ctx.restore();

        // Draw Project Name in Center of Capsule Pill with 10px horizontal padding & ellipsis fallback
        const projectName = (log.project_name || log.project_id || '').trim();
        const horizontalPadding = 10;
        const maxTextWidth = pillW - (horizontalPadding * 2);
        const pillCenter = pillLeft + pillW / 2;

        if (projectName && maxTextWidth > 0) {
          ctx.save();
          ctx.font = '600 11px Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
          ctx.fillStyle = '#ffffff';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';

          const measure = (text: string): number => {
            if (typeof ctx.measureText === 'function') {
              return ctx.measureText(text)?.width ?? text.length * 6;
            }
            return text.length * 6;
          };

          let displayText = projectName;
          const fullWidth = measure(displayText);

          if (fullWidth > maxTextWidth) {
            const ellipsis = '...';
            const ellipsisWidth = measure(ellipsis);
            if (ellipsisWidth <= maxTextWidth) {
              let trimmed = displayText;
              while (trimmed.length > 0 && measure(trimmed + ellipsis) > maxTextWidth) {
                trimmed = trimmed.slice(0, -1);
              }
              displayText = trimmed ? trimmed + ellipsis : '';
            } else {
              displayText = '';
            }
          }

          if (displayText && typeof ctx.fillText === 'function') {
            ctx.fillText(displayText, pillCenter, yCenter);
          }
          ctx.restore();
        }

        this.renderedConductPills.push({
          x1: xStart - 4,
          x2: xEnd + 4,
          y1: yCenter - 11,
          y2: yCenter + 11,
          centerX: (xStart + xEnd) / 2,
          log,
          timeRangeText,
          durationText,
          activeOverlapText,
          idleSecs,
          offlineSecs,
          idleText,
          offlineText,
          superSeeTimeRangeText: overlapDetails.superSeeTimeRangeText,
          superSeeDurationText: overlapDetails.superSeeDurationText,
          differenceSecs,
          differenceText,
          color: logColor
        });
      });
    }
  }

  private drawFallbackRoundRect(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, r: number): void {
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + w - r, y);
    ctx.quadraticCurveTo(x + w, y, x + w, y + r);
    ctx.lineTo(x + w, y + h - r);
    ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    ctx.lineTo(x + r, y + h);
    ctx.quadraticCurveTo(x, y + h, x, y + h - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
  }

  calculateSuperSeeActiveOverlapDetails(rowIndex: number, taskStartMin: number, taskEndMin: number): SuperSeeOverlapDetails {
    const daySessions = this.newSessionData?.[rowIndex] || [];
    return this.conductService.calculateSuperSeeOverlapDetails(daySessions, taskStartMin, taskEndMin);
  }

  private calculateSuperSeeActiveOverlapSeconds(rowIndex: number, taskStartMin: number, taskEndMin: number): number {
    return this.conductService.calculateSuperSeeOverlapSeconds(this.newSessionData?.[rowIndex] || [], taskStartMin, taskEndMin);
  }

  private isMouseOverConductPill(e?: MouseEvent): boolean {
    if (!e || !this.renderedConductPills.length || !this.chart?.canvas) return false;
    const rect = this.chart.canvas.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;
    return this.renderedConductPills.some(
      (p) => mouseX >= p.x1 && mouseX <= p.x2 && mouseY >= p.y1 && mouseY <= p.y2
    );
  }

  private handleCanvasMouseMove(e: MouseEvent): void {
    if (this.type !== 'horizontal' || !this.renderedConductPills.length || !this.chart?.canvas) {
      return;
    }

    const rect = this.chart.canvas.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;

    const hitPill = this.renderedConductPills.find(
      (p) => mouseX >= p.x1 && mouseX <= p.x2 && mouseY >= p.y1 && mouseY <= p.y2
    );

    if (hitPill) {
      this.chart.canvas.style.cursor = 'pointer';
    }
  }

  private handleCanvasMouseLeave(): void {
    // Retain click-opened conduct task tooltip when mouse leaves the canvas
  }

  private handleCanvasClick(e: MouseEvent): void {
    if (this.type !== 'horizontal' || !this.chart?.canvas) {
      return;
    }

    if (!this.renderedConductPills.length) {
      if (this.hoveredConductTask) {
        this.hoveredConductTask = null;
        this.chart.render();
        this.cdr.markForCheck();
      }
      return;
    }

    const rect = this.chart.canvas.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;

    const hitPill = this.renderedConductPills.find(
      (p) => mouseX >= p.x1 && mouseX <= p.x2 && mouseY >= p.y1 && mouseY <= p.y2
    );

    if (hitPill) {
      // Prevent Chart.js from clearing tooltips or selecting rows
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (this.hoveredConductTask === hitPill.log) {
        // Toggle off if clicking the already open task
        this.hoveredConductTask = null;
      } else {
        this.hoveredConductTask = hitPill.log;
        this.hoveredConductTaskColor = hitPill.color || this.getConductLogColor(hitPill.log);
        this.hoveredConductTaskTimeRange = hitPill.timeRangeText;
        this.hoveredConductTaskDuration = hitPill.durationText;
        this.hoveredConductActiveInWindow = hitPill.activeOverlapText;
        this.hoveredConductIdleSecs = hitPill.idleSecs || 0;
        this.hoveredConductIdleText = hitPill.idleText || '';
        this.hoveredConductOfflineSecs = hitPill.offlineSecs || 0;
        this.hoveredConductOfflineText = hitPill.offlineText || '';
        this.hoveredSuperSeeTimeRange = hitPill.superSeeTimeRangeText;
        this.hoveredSuperSeeDuration = hitPill.superSeeDurationText;
        this.hoveredConductTimeDifferenceSecs = hitPill.differenceSecs;
        this.hoveredConductTimeDifference = hitPill.differenceText;

        // Position tooltip strictly within section boundaries
        this.updateConductTooltipPosition(hitPill);

        // Close row app usage popup if open
        this.selectedRowIndex = null;
      }

      this.chart.render();
      this.cdr.detectChanges();

      if (this.conductTooltipRef?.nativeElement) {
        const el = this.conductTooltipRef.nativeElement as HTMLElement;
        const actualW = el.offsetWidth;
        const actualH = el.offsetHeight;
        if (actualW > 0 && actualH > 0) {
          this.updateConductTooltipPosition(hitPill, actualW, actualH);
          this.cdr.markForCheck();
        }
      }
    } else {
      if (this.hoveredConductTask) {
        this.hoveredConductTask = null;
        this.chart.render();
        this.cdr.markForCheck();
      }
    }
  }

  /**
   * Adjusts the Conduct task tooltip position so it opens strictly within the
   * timeline section boundaries (preventing it from hiding behind the left navigation drawer or clipping right).
   */
  updateConductTooltipPosition(
    hitPill: { centerX: number; y1: number; y2: number },
    measuredWidth?: number,
    measuredHeight?: number
  ): void {
    if (!this.chart?.canvas) return;

    const host = this.el?.nativeElement as HTMLElement | undefined;
    const cardEl = host?.closest ? (host.closest('.workin-card') as HTMLElement | null) : null;
    const shellEl = host?.querySelector ? (host.querySelector('.timeline-chart-shell') as HTMLElement | null) : null;
    const canvasEl = this.chart.canvas as HTMLElement | undefined;
    const sectionEl = shellEl || cardEl || canvasEl || host;

    const hostRect = sectionEl?.getBoundingClientRect ? sectionEl.getBoundingClientRect() : null;
    const canvasRect = this.chart.canvas.getBoundingClientRect();

    const sectionRect =
      hostRect && hostRect.width > 0 && (hostRect.left > 0 || !canvasRect || canvasRect.left <= 0)
        ? hostRect
        : (canvasRect && canvasRect.width > 0
          ? canvasRect
          : new DOMRect(0, 0, window.innerWidth || 1200, window.innerHeight || 800));

    const tipW =
      measuredWidth ||
      this.conductTooltipRef?.nativeElement?.offsetWidth ||
      380;
    const tipH =
      measuredHeight ||
      this.conductTooltipRef?.nativeElement?.offsetHeight ||
      280;

    // Pill center in viewport coordinates
    const pillCenterX = canvasRect.left + hitPill.centerX;
    const idealLeft = pillCenterX - tipW / 2;

    // Boundary limits within the section (never hide behind left drawer or overflow right)
    const margin = 12;
    const minLeft = Math.max(margin, sectionRect.left + margin);
    const maxLeft = Math.min(window.innerWidth - tipW - margin, sectionRect.right - tipW - margin);

    let finalLeft: number;
    if (maxLeft < minLeft) {
      finalLeft = Math.max(margin, Math.min(window.innerWidth - tipW - margin, sectionRect.left + margin));
    } else {
      finalLeft = Math.max(minLeft, Math.min(maxLeft, idealLeft));
    }

    // Vertical positioning: default above the pill, flip below if not enough room above
    const pillTop = canvasRect.top + hitPill.y1;
    const pillBottom = canvasRect.top + hitPill.y2;
    const gap = 10;
    const idealTop = pillTop - tipH - gap;

    const minTop = Math.max(margin, sectionRect.top + margin);
    let finalTop: number;

    if (idealTop >= minTop) {
      finalTop = idealTop;
    } else {
      // Not enough space above the pill, try placing below
      const belowTop = pillBottom + gap;
      if (belowTop + tipH <= window.innerHeight - margin) {
        finalTop = belowTop;
      } else {
        finalTop = Math.max(margin, idealTop);
      }
    }

    this.conductTooltipX = Math.round(finalLeft);
    this.conductTooltipY = Math.round(finalTop);
  }

  navigateToWorkReplay(task?: ConductTimelog | null): void {
    const t = task || this.hoveredConductTask;
    if (!t) return;

    const employeeId = t.supersee_user_id ?? t.supersee_user ?? this.currentId ?? (Array.isArray(this.id) ? this.id[0] : this.id);
    const rawDate = t.log_date || t.date || this.startDate;
    const dateStr = rawDate ? moment(rawDate).format('YYYY-MM-DD') : null;

    const queryParams: Record<string, string | number> = {};
    if (employeeId != null && employeeId !== '') {
      queryParams['employeeId'] = employeeId;
    }
    if (dateStr) {
      queryParams['date'] = dateStr;
    }
    queryParams['showConduct'] = 'true';
    if (t.project_name && String(t.project_name).trim()) {
      queryParams['project'] = String(t.project_name).trim().toLowerCase();
    }
    const rawTime = t.from_time || (t as any).start_time;
    if (rawTime && String(rawTime).trim()) {
      queryParams['time'] = String(rawTime).trim();
    }

    this._sharedService?.componentDrawerSubject.next({
      componentName: 'conduct-timelogs',
      componentAction: 'close',
      componentData: null,
      componentWidth: 0
    });
    void this.router.navigate(['/work-replay'], { queryParams });
  }

  parseLogStartMinute(log: ConductTimelog): number {
    return this.conductService.parseLogStartMinute(log);
  }

  parseLogEndMinute(log: ConductTimelog, startMin: number): number {
    return this.conductService.parseLogEndMinute(log, startMin);
  }

  getConductLogColor(log?: ConductTimelog): string {
    return this.conductService.getConductLogColor(log, this.conductProjectColorMap, this.conductBarColors);
  }

  private refreshDistinctConductProjects(): void {
    this.distinctConductProjects = this.conductService.getDistinctConductProjects(
      this._conductTimelogs,
      this.conductProjectColorMap,
      this.conductBarColors
    );
  }

  getConductLogDurationSeconds(log: ConductTimelog, fallbackSecs: number): number {
    return this.conductService.getDurationSeconds(log, fallbackSecs);
  }

  private isLogOnDay2(log: ConductTimelog): boolean {
    return this.conductService.isLogOnDay2(log, this.startDate, this.endDate);
  }

  formatActiveOverlapDisplay(seconds: number): string {
    return this.conductService.formatActiveOverlapDisplay(seconds);
  }

  formatDurationHhMmDisplay(seconds: number): string {
    return this.conductService.formatDurationHrsMins(seconds);
  }

  parseTimeToMinutes(timeVal: unknown): number {
    return this.conductService.parseTimeToMinutes(timeVal);
  }

  minutesTo12h(minutes: number): string {
    return this.conductService.minutesTo12h(minutes);
  }
}

